import { ButtonTypes } from '@celito.clients/enums';
import { CustomButton } from '@celito.clients/shared';
import { useFormContext } from 'react-hook-form';

import { FormMode } from '../../document-templates/types';
import { TFieldValues } from '../screens/edit/controller';
import { getStyles } from '../styles';

export const ActionsFooter = ({
  handleSubmit,
  onCancel,
  mode,
  disableSubmit = false,
}: {
  handleSubmit: () => void;
  onCancel: () => void;
  mode: FormMode;
  disableSubmit?: boolean;
}) => {
  const styles = getStyles();

  if (mode === FormMode.VIEW) {
    return (
      <div className={styles.footer}>
        <CustomButton
          type="button"
          buttonType={ButtonTypes.Ghost}
          buttonTitle="Cancel"
          onClick={onCancel}
        />
      </div>
    );
  }

  const InlineActions = () => {
    const {
      formState: { isDirty, isSubmitting, dirtyFields },
    } = useFormContext<TFieldValues>();

    const disableSave =
      Object.keys(dirtyFields).length > 1 && dirtyFields.documentSubType
        ? false
        : disableSubmit;
    return (
      <div className={styles.footer}>
        <CustomButton
          type="button"
          buttonType={ButtonTypes.Ghost}
          buttonTitle="Cancel"
          onClick={onCancel}
        />
        <CustomButton
          type="button"
          disabled={!isDirty || disableSave}
          buttonType={ButtonTypes.Primary}
          isLoading={isSubmitting}
          onButtonClicked={handleSubmit}
          buttonTitle={(() => {
            if (mode === FormMode.EDIT)
              if (isSubmitting) return 'Saving';
              else return 'Save';
            else if (isSubmitting) return 'Creating';
            else return 'Create';
          })()}
          leftIcon="Save"
        />
      </div>
    );
  };

  return <InlineActions />;
};
